export default __webpack_public_path__ + "static/Inter-Italic-e8cc3f197dda11de173b46432e3c5f32.woff2";